var star1 = "/static/a37f1b062005e9b8.webp";

export { star1 as default };
//# sourceMappingURL=star-1.webp.js.map
